import React, { useState } from 'react';
import { LandingScreen } from './components/LandingScreen';
import { TextChat } from './components/TextChat';
import { VideoChat } from './components/VideoChat';
import { useSocket } from './hooks/useSocket';
import './index.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('landing');
  const [selectedChatType, setSelectedChatType] = useState(null);
  
  const {
    socket,
    isConnected,
    status,
    partnerId,
    roomId,
    chatType,
    messages,
    findMatch,
    sendMessage,
    nextPartner,
    disconnectChat
  } = useSocket();

  const handleSelectChatType = (type) => {
    setSelectedChatType(type);
    setCurrentScreen('chat');
    findMatch(type);
  };

  const handleBack = () => {
    disconnectChat();
    setCurrentScreen('landing');
    setSelectedChatType(null);
  };

  const handleNext = () => {
    nextPartner();
    if (selectedChatType) {
      findMatch(selectedChatType);
    }
  };

  const handleDisconnect = () => {
    disconnectChat();
    setCurrentScreen('landing');
    setSelectedChatType(null);
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case 'landing':
        return <LandingScreen onSelectChatType={handleSelectChatType} />;
      
      case 'chat':
        if (selectedChatType === 'text') {
          return (
            <TextChat
              status={status}
              messages={messages}
              onSendMessage={sendMessage}
              onNext={handleNext}
              onDisconnect={handleDisconnect}
              onBack={handleBack}
            />
          );
        } else if (selectedChatType === 'video') {
          return (
            <VideoChat
              socket={socket}
              status={status}
              partnerId={partnerId}
              onNext={handleNext}
              onDisconnect={handleDisconnect}
              onBack={handleBack}
            />
          );
        }
        break;
      
      default:
        return <LandingScreen onSelectChatType={handleSelectChatType} />;
    }
  };

  return (
    <div className="App">
      {renderScreen()}
    </div>
  );
}

export default App; 